import React from "react";
import { Card, Placeholder } from "react-bootstrap";

const ChartSkeleton = () => {
  return (
    <Card style={{ height: "400px", width: "100%" }} className="p-3">
      {/* Title Placeholder */}
      <Placeholder as="h5" animation="wave" className="mb-3">
        <Placeholder xs={3} className="bg-secondary rounded" />
      </Placeholder>

      {/* Fake Chart Area */}
      <div className="d-flex flex-column justify-content-between h-100">
        {/* Y-axis fake lines */}
        {[...Array(5)].map((_, i) => (
          <div
            key={i}
            className="d-flex align-items-center"
            style={{ height: "15%" }}
          >
            {/* Line */}
            <div className="w-100">
              <div
                className="bg-secondary rounded"
                style={{ height: "8px", width: `${60 + i * 10}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default ChartSkeleton;
